module.exports = __webpack_public_path__ + "img/lemon_and_mint_2.3f4bf8a4.png";